import React, { useEffect, useState } from "react";
import axios from "axios";
import { FileText } from "lucide-react";
import { FiDownload } from "react-icons/fi";
import { Base_Url, fetchUser, UploadCsv } from "../../../../../config/config";
import toast from "react-hot-toast";


const PricingTemplateUpload = () => {
  const [zoneFile, setZoneFile] = useState(null);
  const [vasFile, setVasFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const cus_id = localStorage.getItem("cus_id");
  const [retailers, setRetailers] = useState([]);
  const [selectedRetailer, setSelectedRetailer] = useState("");
  const [selectedCourier, setSelectedCourier] = useState("");
  const [selectedCftType, setSelectedCftType] = useState('');

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const courierPartners = [
    { id: "delhivery", name: "Delhivery" },
    { id: "movin", name: "Movin" },
    { id: "gati", name: "Gati" },
  ];
  const fetchRetailers = async () => {
    const url = Base_Url + fetchUser;
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cus_id,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.status === "success") {
        const transformedData = data.data.map((user) => {
          const capitalizedName =
            user.name.charAt(0).toUpperCase() + user.name.slice(1);
          return {
            value: user.id,
            label: `${capitalizedName} (${user.id})`,
          };
        });
        setRetailers(transformedData);
      } else {
        setError(data.message || "Failed to fetch retailers");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRetailers();
  }, []);

  /* ================= UPLOAD HANDLER ================= */
  const handleUpload = async () => {
    setSuccessMessage("");
    setError("");

    if (!selectedRetailer || !selectedCourier) {
      toast.error("Please select Retailer and Courier Partner");
      return;
    }

    if (!zoneFile || !vasFile) {
      toast.error("Please upload both CSV files");
      return;
    }

    const formData = new FormData();
    formData.append("retailer_id", selectedRetailer);
    formData.append("type", selectedCftType);
    formData.append("courier_partner", selectedCourier);
    formData.append("zone_pricing", zoneFile);
    formData.append("vas_pricing", vasFile);

    try {
      setLoading(true);

      const res = await axios.post(
        Base_Url + UploadCsv,
        formData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status === "success") {
        toast.success(res.data.message || "Pricing uploaded successfully ✅");
        setSuccessMessage(res.data.message || "Pricing uploaded successfully ✅");
      } else {
        toast.error(res.data.message || "Failed to upload pricing ❌");
        setError(res.data.message || "Failed to upload pricing ❌");
      }
    } catch (error) {
      const errMsg = error?.response?.data?.message || "Failed to upload pricing ❌";
      toast.error(errMsg);
      setError(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-4">
        {/* ================= DROPDOWNS ================= */}
        {/* ================= TEMPLATE DOWNLOAD ================= */}
        {successMessage && (
          <div className="flex justify-end">
            <div className="bg-green-50 border border-green-300 flex justify-center w-[24%] text-green-700 text-xs rounded-lg px-3 py-2  items-center gap-2">
              ✅ {successMessage}
            </div>
          </div>
        )}
        {error &&
          <div className="flex justify-end">
            <div className="bg-red-100 border-red-800 border flex justify-center items-center rounded-lg w-[23%] py-2">
              <p className="text-red-500 text-xs">{error}</p>
            </div>
          </div>
        }
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 rounded-xl p-4 border border-indigo-200 dark:border-indigo-800">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full">
                <FileText className="w-4 h-4 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-xs">Need a template?</h3>
                <p className="text-[11px] text-gray-600">
                  Download sample CSV files
                </p>
              </div>
            </div>

            <div className="flex gap-2">

              <a href="/sampleFile/b2brate.csv"
                download
                className="px-3 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl text-xs flex items-center gap-1"
              >
                <FiDownload /> B2B Rate
              </a>


              <a href="/sampleFile/b2bratevas.csv"
                download
                className="px-3 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl text-xs flex items-center gap-1"
              >
                <FiDownload /> VAS Rate
              </a>
            </div>
          </div>
        </div>
        <div className="border rounded-lg shadow-lg">
          <div className="bg-white  p-3 sm:p-2 lg:p-4 mt-4">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {/* Retailer */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Select Retailer <span className="text-red-500">*</span>
                </label>
                <select
                  value={selectedRetailer}
                  onChange={(e) => setSelectedRetailer(e.target.value)}
                  disabled={loading}
                  className="w-full px-2 py-1 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">
                    {loading ? "Loading retailers..." : "-- Select Retailer --"}
                  </option>
                  {retailers.map((retailer) => (
                    <option key={retailer.value} value={retailer.value}>
                      {retailer.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Courier */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Select Courier Partner <span className="text-red-500">*</span>
                </label>
                <select
                  value={selectedCourier}
                  onChange={(e) => setSelectedCourier(e.target.value)}
                  className="w-full px-2 py-1 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">-- Select Courier Partner --</option>
                  {courierPartners.map((courier) => (
                    <option key={courier.id} value={courier.id}>
                      {courier.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* Retailer */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium text-gray-700">Select CFT <span className="text-red-500">*</span></label>
                <select
                  value={selectedCftType}
                  onChange={(e) => setSelectedCftType(e.target.value)}
                  disabled={loading}
                  className="h-[36px] px-3 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                  <option value="">-- Select CFT --</option>
                  <option value="lite">Lite</option>
                  <option value="heavy">Heavy</option>
                  <option value="dense">Dense</option>
                </select>
              </div>

              {/* <div className="flex flex-col gap-1">
                                                  <label className="text-xs font-medium text-gray-700">Select CFT <span className="text-red-500">*</span></label>
                                                  <select
                                                      value={selectedCftType}
                                                      onChange={(e) => setSelectedCftType(e.target.value)}
                                                      disabled={loading}
                                                      className="h-[36px] px-3 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                                  >
                                                      <option value="">-- Select CFT --</option>
                                                      <option value="lite">Lite</option>
                                                      <option value="heavy">Heavy</option>
                                                      <option value="dense">Dense</option>
                                                  </select>
                                              </div> */}

            </div>
          </div>
          {/* ================= FILE UPLOAD ================= */}
          <div className="bg-white  p-3 sm:p-2 lg:p-4 mb-4 sm:mb-6 ">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium text-gray-700">
                  Zone Pricing CSV <span className="text-red-500">*</span>
                </label>
                <label className="cursor-pointer border border-dashed border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-600 hover:border-indigo-400">
                  {zoneFile ? zoneFile.name : "Choose Zone Pricing CSV"}
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => setZoneFile(e.target.files[0])}
                    className="hidden"
                  />
                </label>
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium text-gray-700">
                  VAS Pricing CSV <span className="text-red-500">*</span>
                </label>
                <label className="cursor-pointer border border-dashed border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-600 hover:border-indigo-400">
                  {vasFile ? vasFile.name : "Choose VAS Pricing CSV"}
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => setVasFile(e.target.files[0])}
                    className="hidden"
                  />
                </label>
              </div>
              <button
                onClick={handleUpload}
                disabled={loading}
                className="h-[36px] px-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl text-xs font-semibold disabled:opacity-60"
              >
                {loading ? "Uploading..." : "Upload Pricing"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingTemplateUpload;